module.exports = __webpack_public_path__ + "img/meydon.2003a89.png";